import React, { useEffect } from "react";
import "./SurveyResponse.css"; // Import CSS file
import CheckIcon from "../../../assets/CheckIcon.svg"; // Import the SVG
import { useTranslation } from "react-i18next";

const usePreventBack = () => {
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const onPopState = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, []);
}

export default function SurveyResponse() {
  usePreventBack();
  const { title, endDate } = JSON.parse(sessionStorage.getItem("surveyResponseData") || "{}");
  const { t } = useTranslation();

  return (
    <div className="survey-survey-response-container1">
      <div className="row center-xs middle-xs" style={{ minHeight: "80vh" }}>
        <div className="col-xs-12">
          <div className="row center-xs">
            <div className="col-xs-12 col-md-8" style={{ textAlign: "center" }}>
              <h2>{title}</h2>
              {/* <p>
                <Moment format="DD MMM YYYY">
                  {new Date()}
                </Moment>
              </p> */}
            </div>
          </div>
          <div className="row center-xs">
            <div className="col-xs-12">
              <img
                src={CheckIcon}
                alt="Success"
                className="tick-icon"
                style={{ width: 40, height: 40 }}
              />
            </div>
          </div>
          <div className="row center-xs">
            <div className="col-xs-12">
              <p className="survey-submission-text1">
                  <b>{t("thankYou")}</b> <br />
                  <span>{t("responseSubmitted")}</span>
                  <br />
                  <span>{t("pleaseCloseWindow")}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}